import api from '@/api/axios';

export async function getSettings(){
  const response = await api.get('/settings');
  return response.data;
}
